"use client";

import { CcDemoTabs } from "@/components/services/shared/CcDemoTabs";
import { CcSanjayaEyebrow } from "@/components/ui/CcSanjayaEyebrow";
import { devSectionAttr } from "@/lib/dev/section-attr";

import type { LeadGenDemoCopy } from "./lead-gen-demo-copy";
import {
  LeadAccountsPhotoView,
  LeadMeetingsPhotoView,
  LeadSequencesPhotoView,
} from "./CcLeadValuePhotoViews";

type CcLeadValueProps = {
  copy: LeadGenDemoCopy;
};

/**
 * "Värdet av personliga utskick": three tabs following one made-up B2B
 * company (the right accounts → personal sequences → booked meetings) as
 * real photos with cards and the real tools' logos. Same section layout and
 * styles as the other service demos.
 */
export function CcLeadValue({ copy }: CcLeadValueProps) {
  return (
    <section
      className="cc-section cc-seo-value"
      aria-labelledby="cc-lead-value-title"
      data-cc-nav="light"
      {...devSectionAttr("lead-value")}
    >
      <div className="cc-container">
        <header className="cc-seo-value__header">
          <CcSanjayaEyebrow theme="on-subtle">{copy.eyebrow}</CcSanjayaEyebrow>
          <h2 id="cc-lead-value-title" className="cc-seo-heading">
            {copy.title}
          </h2>
          <p className="cc-seo-lead cc-seo-value__lead">{copy.lead}</p>
        </header>

        <CcDemoTabs
          tablistLabel={copy.tablistLabel}
          disclaimer={copy.disclaimer}
          tabs={[
            {
              key: "accounts",
              label: copy.tabs.accounts,
              summary: copy.accounts.summary,
              content: <LeadAccountsPhotoView copy={copy.accounts} />,
            },
            {
              key: "sequences",
              label: copy.tabs.sequences,
              summary: copy.sequences.summary,
              content: <LeadSequencesPhotoView copy={copy.sequences} />,
            },
            {
              key: "meetings",
              label: copy.tabs.meetings,
              summary: copy.meetings.summary,
              content: <LeadMeetingsPhotoView copy={copy.meetings} />,
            },
          ]}
        />

        <p className="cc-seo-value__footnote">{copy.footnote}</p>
      </div>
    </section>
  );
}
